import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { getImageSpec } from '@/utils/locals';
import EFArrowRightBlueSmall from '@/components/UI/svg/Icons/EFArrowRightBlueSmall';
import EFVideo from '@/components/UI/EFVideo';

export default function Charge({}: any) {
    const { useState, useLang, useRouter, Link } = useGlobal();
    const { locale } = useRouter();
    const videoLocal = getImageSpec(locale, ['au', 'uk', 'cn', 'de', 'fr', 'es', 'it', 'eu']);
    const { t } = useLang('delta_max_static');
    const isShowLink = ['us', 'ca', 'au', 'uk', 'za', 'sa', 'eu'].includes(locale);

    const tabList = [
        {
            tabTitle: t('X-Stream AC'),
            video: [`/video/deltamax-h5/max-chirang-0_${videoLocal}.webm`, `/video/deltamax-h5/max-chirang-0_${videoLocal}.mp4`],
        },
        {
            tabTitle: t('Solar + AC'),
            video: [`/video/deltamax-h5/max-chirang-1_${videoLocal}.webm`, `/video/deltamax-h5/max-chirang-1_${videoLocal}.mp4`],
        },
        {
            tabTitle: t('Solar + Smart Generator'),
            video: [`/video/deltamax-h5/max-chirang-2_${videoLocal}.webm`, `/video/deltamax-h5/max-chirang-2_${videoLocal}.mp4`],
        },
        {
            tabTitle: t('Smart Generator + AC'),
            video: [`/video/deltamax-h5/max-chirang-3_${videoLocal}.webm`, `/video/deltamax-h5/max-chirang-3_${videoLocal}.mp4`],
        },
    ];
    const [currentIndex, setCurrentIndx] = useState(0);
    const [tabPosition, setTabPosition] = useState({});

    const checkTab = (indx: number, e: any) => {
        setCurrentIndx(indx);
        const dom = e.target;
        const { clientWidth, offsetLeft } = dom;
        setTabPosition({
            width: `${clientWidth}px`,
            left: `${offsetLeft}px`,
        });
    };

    return (
        <div className={css.charge}>
            <div className="video-wrapper">
                <EFVideo className={`video ${currentIndex === 0 ? 'show' : ''}`} sources={tabList[0]?.video} />
                <EFVideo className={`video ${currentIndex === 1 ? 'show' : ''}`} sources={tabList[1]?.video} />
                <EFVideo className={`video ${currentIndex === 2 ? 'show' : ''}`} sources={tabList[2]?.video} />
                <EFVideo className={`video ${currentIndex === 3 ? 'show' : ''}`} sources={tabList[3]?.video} />
            </div>
            <div className="tab">
                <div className="tab-container">
                    <ul>
                        {tabList.map((item, indx) => (
                            <li key={indx} onClick={(e) => checkTab(indx, e)} className={currentIndex === indx ? 'active' : ''}>
                                {item.tabTitle}
                            </li>
                        ))}
                    </ul>
                    <div className="line" style={tabPosition} />
                </div>
            </div>
            <div className="content">
                {currentIndex === 0 && (
                    <div className="section1 section">
                        <div className="title charging">{t('Fast Charging')}</div>
                        <p className="subtitle">{t('FC_desc')}</p>
                        {isShowLink && (
                            <Link href="/x-stream" className="stream-link" newWin>
                                <div className="link font-family-regular">
                                    <span>{t('x_stream_link')}</span>
                                    <EFArrowRightBlueSmall />
                                </div>
                            </Link>
                        )}
                        <div className="btm">
                            <div className="btm-left">
                                <p className="pretitle">{t('Input')}</p>
                                <p className="title">{t('FC_1800')}</p>
                                <p className="subtitle">{t('FC_input')}</p>
                            </div>
                            <div className="btm-right">
                                <p className="pretitle">{t('Full Charge')}</p>
                                <p className="title">
                                    {t('FC_charge_time')}
                                    <span className="title-union">{t('Hrs')}</span>
                                </p>
                            </div>
                        </div>
                    </div>
                )}
                {currentIndex === 1 && (
                    <div className="section2 section">
                        <div className="title">
                            {t.rich('TPS', {
                                line1: (child: string) => <span className="font-yellow">{child}</span>,
                            })}
                        </div>
                        <p className="subtitle">{t('TPS_desc')}</p>
                        <div className="btm">
                            <div className="btm-left">
                                <p className="pretitle">{t('Input')}</p>
                                <p className="title">{t('TPS_AC_input')}</p>
                            </div>
                            <div className="btm-right">
                                <p className="pretitle">{t('Full Charge')}</p>
                                <p className="title">
                                    {t('TPS_AC_charge')}
                                    <span className="title-union">{t('Hrs')}</span>
                                </p>
                            </div>
                        </div>
                    </div>
                )}
                {currentIndex === 2 && (
                    <div className="section2 section">
                        <div className="title">
                            {t.rich('TPS', {
                                line1: (child: string) => <span className="font-yellow">{child}</span>,
                            })}
                        </div>
                        <p className="subtitle">{t('TPS_desc1')}</p>
                        <div className="btm">
                            <div className="btm-left">
                                <p className="pretitle">{t('Input')}</p>
                                <p className="title">{t('TPS_AC_input')}</p>
                            </div>
                            <div className="btm-right">
                                <p className="pretitle">{t('Full Charge')}</p>
                                <p className="title">
                                    {t('TPS_AC_charge')}
                                    <span className="title-union">{t('Hrs')}</span>
                                </p>
                            </div>
                        </div>
                    </div>
                )}
                {currentIndex === 3 && (
                    <div className="section4 section">
                        <div className="title">
                            {t.rich('STDC', {
                                line1: (child: string) => <span className="font-green">{child}</span>,
                            })}
                        </div>
                        <p className="subtitle">{t('STDC_desc')}</p>
                        <div className="btm">
                            <div className="btm-left">
                                <p className="pretitle">{t('Input')}</p>
                                <p className="title">{t('STDC_input')}</p>
                            </div>
                            <div className="btm-right">
                                <p className="pretitle">{t('Full Charge')}</p>
                                <p className="title">
                                    {t('STDC_charge')}
                                    <span className="title-union">{t('Hrs')}</span>
                                </p>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
